import script from "./SimilarPosts.vue?vue&type=script&setup=true&lang=js"
export * from "./SimilarPosts.vue?vue&type=script&setup=true&lang=js"

import "./SimilarPosts.vue?vue&type=style&index=0&id=d9180346&lang=scss"

const __exports__ = script;

export default __exports__